import React from "react";


//Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

//Charts
import Chart from 'react-apexcharts'

export default class LineView extends React.Component {

    
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  };

  handleClose = () => {
    this.setState({
        open: false
    });
    this.props.onClick(this.state.open);  

}

render(){

  return (

          <Dialog
           open={this.props.open}
           aria-labelledby="alert-dialog-title"
           aria-describedby="alert-dialog-description"
           maxWidth= {'md'}
         >
           <DialogTitle id="alert-dialog-title">{"Line Chart"}</DialogTitle>
           <DialogContent>
 
           <Chart options={this.props.options} series={this.props.options.series} type='area' width="800" height='auto'></Chart>
 
 
        </DialogContent>
           <DialogActions>
           <Button onClick={ this.handleClose} color="primary" style={{marginLeft:800}}>
                 Close
               </Button>
           </DialogActions>
        </Dialog> 


      );
  
  }

}
